var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 1H15L7 9.005v30.017a2.002 2.002 0 0 0 2 2h29a2 2 0 0 0 2-2V3.002A2.002 2.002 0 0 0 38 1z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7 10.005h9V1l-9 9.005z",
    fill: "#B6C4D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.005h6V4",
    stroke: "#293041",
    strokeOpacity: 0.7,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41.023h7a2 2 0 0 0 2-2.001V3.002A2.002 2.002 0 0 0 38 1H15L7 9.005v30.017a2.002 2.002 0 0 0 2 2h8",
    stroke: "#293041",
    strokeOpacity: 0.7,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.36 26.983V38.99h8V26.983h4.82l-9-10.976-9 10.976h5.18z",
    fill: "#00AAB5",
    stroke: "#293041",
    strokeOpacity: 0.7,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.36 45.994h8v-4.002h-8v4.002z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.36 41.992v4.002h8v-4.002",
    stroke: "#293041",
    strokeOpacity: 0.7,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.36 51.998h8v-3.002h-8v3.002z",
    fill: "#00AAB5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.36 48.996v3.002h8v-3.002",
    stroke: "#293041",
    strokeOpacity: 0.7,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51 23.012V2M46 51.028v-18.01M46 30.016v-2M46 25.014v-2.001M46 20.01v-2M1 44.024v-18.01",
    stroke: "#BCC0C4",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/uploadImg.4097e18e828d4d4738979da5ce5358c0.svg";
export { ForwardRef as ReactComponent };